import {Plugin} from 'vue'
import {trackDirective} from '@/composables'

export const analytics: Plugin = (app) => {
  app.directive('track', trackDirective)
}
export default analytics
